import React from 'react';
import { FileCheckIcon, MapPinIcon, UserIcon, HomeIcon, MapIcon, HistoryIcon, ShieldCheckIcon, InfoIcon, FileTextIcon, ShieldIcon, CalendarCheckIcon } from 'lucide-react';
import { PERMIS_IMAGES } from '../../../data/permisHero';
import { propertyContext, verifiedAnswer, type Bi } from '../../../data/permisSolution';
import { CARD, GreenCheck } from '../PermisCards';
type P = {
  isFR: boolean;
};
const pk = (isFR: boolean) => (v: Bi) => isFR ? v.fr : v.en;
const PROP_ICONS = {
  id: UserIcon,
  address: HomeIcon,
  zoning: MapIcon,
  history: HistoryIcon
} as const;
const VER_ICONS = {
  city: MapPinIcon,
  property: UserIcon,
  rule: FileTextIcon,
  version: ShieldIcon,
  date: CalendarCheckIcon
} as const;
export function PropertyContextCard({
  isFR
}: P) {
  const pick = pk(isFR);
  return <div className={`${CARD} rounded-[22px] p-4 h-full`} data-id="element-5160" data-mp="bzf3rbw7nnar">
      <p className="flex items-center gap-2.5 font-sans text-[14px] font-semibold text-[#121A3A]" data-id="element-5161" data-mp="c0zyp2mft895">
        <FileCheckIcon className="w-5 h-5 text-[#4F46E5]" strokeWidth={1.8} aria-hidden="true" data-id="element-5162" data-mp="g23hnxzs7kel" />
        {pick(propertyContext.title)}
        <GreenCheck size={17} data-id="element-5163" data-mp="mhr0mwzdzzi6" />
      </p>
      <div className="relative mt-3.5 h-[150px] rounded-xl overflow-hidden" data-id="element-5164" data-mp="mitpkzd5frvg">
        <img src={PERMIS_IMAGES.parcel} alt="" className="absolute inset-0 w-full h-full object-cover" data-id="element-5165" data-mp="hhmht0b0asos" />
        <svg viewBox="0 0 200 150" className="absolute inset-0 w-full h-full" preserveAspectRatio="none" aria-hidden="true" data-id="element-5166" data-mp="dgkk4nwqmoox">
          <g stroke="#FFFFFF" strokeOpacity="0.5" strokeWidth="0.8" fill="none" data-id="element-5167" data-mp="8kc8hkhr1dmi">
            <path d="M0 50 L200 38 M0 110 L200 100 M60 0 L52 150 M140 0 L148 150" data-id="element-5168" data-mp="3py4itp0ty68" />
          </g>
          <polygon points="62,54 138,46 144,104 68,112" fill="#6D5DF6" fillOpacity="0.45" stroke="#FFFFFF" strokeWidth="1.5" data-id="element-5169" data-mp="3uyddrjyyqk3n" />
        </svg>
        <span className="absolute left-1/2 top-[48%] -translate-x-1/2 -translate-y-full w-9 h-9 rounded-full bg-white shadow-md flex items-center justify-center" aria-hidden="true" data-id="element-5170" data-mp="3lx5ry1dmvbqg">
          <MapPinIcon className="w-5 h-5 text-[#4F46E5] fill-[#4F46E5]/15" strokeWidth={2.2} data-id="element-5171" data-mp="3h0f2wojup5sw" />
        </span>
      </div>
      <ul className="mt-3.5 space-y-2.5" data-id="element-5172" data-mp="3bbsejv31r1ni">
        {propertyContext.items.map(it => {
        const Icon = PROP_ICONS[it.key];
        return <li key={it.key} className="flex items-center gap-3" data-id="element-5173" data-mp="2xdu1qu4djda4">
              <Icon className="w-4 h-4 text-[#4F46E5] shrink-0" strokeWidth={1.8} aria-hidden="true" data-id="element-5174" data-mp="32akhfgc9o6v0" />
              <span className="flex-1 font-sans text-[12px] text-[#121A3A]" data-id="element-5175" data-mp="3q0om7r16ycnl">{pick(it.label)}</span>
              <GreenCheck size={17} data-id="element-5176" data-mp="3v0azg0h0rswe" />
            </li>;
      })}
      </ul>
    </div>;
}
export function VerifiedAnswerCard({
  isFR
}: P) {
  const pick = pk(isFR);
  const v = verifiedAnswer;
  return <div className={`${CARD} rounded-[22px] p-4 h-full flex flex-col`} data-id="element-5177" data-mp="3l8x321kd797h">
      <div className="flex items-start gap-3" data-id="element-5178" data-mp="ctwirtrd94ub">
        <span className="w-10 h-10 rounded-full bg-[#F1F0FD] flex items-center justify-center shrink-0" aria-hidden="true" data-id="element-5179" data-mp="ct3nboxuy1rh">
          <ShieldCheckIcon className="w-5 h-5 text-white fill-[#4F46E5]" strokeWidth={2} data-id="element-5180" data-mp="22bk0h4d3hqef" />
        </span>
        <p className="flex-1 font-sans text-[14px] font-semibold text-[#121A3A] leading-snug" data-id="element-5181" data-mp="1xcgt3d9n783a">{pick(v.title)}</p>
        <InfoIcon className="w-4 h-4 text-[#9A9FB5] shrink-0" aria-hidden="true" data-id="element-5182" data-mp="2b4dih9jxf3vz" />
      </div>
      <ul className="mt-4 space-y-3" data-id="element-5183" data-mp="272ijwctdr4lw">
        {v.items.map(it => {
        const Icon = VER_ICONS[it.key];
        return <li key={it.key} className="flex items-center gap-3" data-id="element-5184" data-mp="1jdh587tyex86">
              <Icon className="w-4 h-4 text-[#4F46E5] shrink-0" strokeWidth={1.8} aria-hidden="true" data-id="element-5185" data-mp="1eduv479f9x3l" />
              <span className="flex-1 font-sans text-[12px] text-[#121A3A]" data-id="element-5186" data-mp="1sdvt9eyayqfd">{pick(it.label)}</span>
              <GreenCheck size={17} data-id="element-5187" data-mp="1ndrnaiv0te3e" />
            </li>;
      })}
      </ul>
      <div className="mt-5 pt-4 border-t border-[#F0F0F5]" data-id="element-5188" data-mp="33sj2tv72iqva">
        <p className="font-sans text-[12px] text-[#3A4050]" data-id="element-5189" data-mp="33qybsfjypq26">{pick(v.scoreLabel)}</p>
        <p className="mt-1.5 flex items-center gap-2.5 font-sans text-[12px] text-[#3A4050]" data-id="element-5190" data-mp="2ysn0s1hxl9id">
          <span className="flex gap-1" aria-hidden="true" data-id="element-5191" data-mp="3u4wk7mq96l4t">
            {[0, 1, 2, 3, 4].map(i => <span key={i} className={`w-3 h-3 rounded-full ${i < v.score ? 'bg-[#22A04F]' : 'bg-[#DCE7DF]'}`} data-id="element-5192" data-mp="2y3a1tdhfbo5" />)}
          </span>
          {pick(v.confidence)}
        </p>
      </div>
      <p className="mt-auto pt-4 font-sans text-[12px] text-[#5B6478] leading-snug" data-id="element-5193" data-mp="cw9a05fqa7qd">{pick(v.note)}</p>
    </div>;
}